const tabs = [
  {
    id: 0,
    tab: 'Tax Info',
  },
  {
    id: 1,
    tab: 'Owner Info',
  },
  {
    id: 2,
    tab: 'Comments',
  },
  {
    id: 3,
    tab: 'Adjustments',
  },
  {
    id: 4,
    tab: 'Mobile',
  },
  {
    id: 5,
    tab: 'History',
  },
  {
    id: 6,
    tab: 'Util',
  },
];

const pickListAndProtestTaxPaymentsTabs = [
  {
    id: 0,
    tab: 'Pick List',
  },
  {
    id: 1,
    tab: 'Protest Tax Payments',
  },
];

const exemptionsList = [
  {
    name: 'H',
    description: 'Homestead',
  },
  {
    name: 'V',
    description: 'Veteran',
  },
  {
    name: 'D',
    description: 'Disabled',
  },
];

const createOmitTabs = [
  {
    id: 0,
    tab: 'Tax Info',
  },
  {
    id: 1,
    tab: 'Owner Name and Address',
  },
  {
    id: 3,
    tab: 'Mobile',
  },
];

export {
  tabs, pickListAndProtestTaxPaymentsTabs, exemptionsList, createOmitTabs,
};
